export function left(time: number, negs = false): number {
  const left1 = Math.floor(time / 1_000) - Math.floor(Date.now() / 1_000);
  const left2 = Math.round(left1) * 1_000;
  return left2 < 0 && !negs ? 0 : left2;
}
